import React from 'react';

const teamRoles = [
  {
    title: "Chief Impact Catalyst",
    points: [
      "Strategic visioning and formulation",
      "Engagement with key stakeholders at senior level",
      "Creation and refinement of documents with clear articulation",
      "Ensuring excellence in the quality of deliverables"
    ],
  },
  {
    title: "Impact Catalyst",
    points: [
      "Overseeing on-site research and community involvement",
      "Regular interaction with clients on a daily basis",
      "Ensuring timely delivery and adherence to deadlines",
      "Dedicated client management"
    ],
  },
  {
    title: "Impact Analyst",
    points: [
      "Analyzing data to evaluate program effectiveness",
      "Creating actionable reports with recommendations",
      "Defining KPIs aligned with organizational goals",
      "Monitoring project progress for optimization"
    ],
  },
];

const TeamStructure = () => {
  return (
    <section className="py-16 bg-white text-primary font-body">
      <div className="max-w-7xl mx-auto px-6 text-center">
        <h2 className="text-4xl font-heading font-bold mb-12 text-secondary">
          Impact Together Team
        </h2>
        <div className="grid md:grid-cols-3 gap-10">
          {teamRoles.map((role, index) => (
            <div
              key={index}
              className="bg-white shadow-xl rounded-2xl border-t-4 border-primary p-6 hover:shadow-2xl transition duration-300"
            >
              <h3 className="text-xl font-semibold font-heading mb-4 text-primary">
                {role.title}
              </h3>
              <ul className="text-left list-disc list-inside space-y-2 text-sm text-gray-700">
                {role.points.map((point, i) => (
                  <li key={i}>{point}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeamStructure;
